import Box from '@mui/material/Box';
import { keyframes } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useMemo } from 'react';

import { AutoRefreshProps } from './Pagination.props';
import { STANDARD_FIELD_HEIGHT } from '../../../configs/ui-constants';
import { DropdownItem, SelectMenu } from '../../atoms/SelectMenu';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.3; }
  100% { opacity: 1; }
`;

const INTERVAL_OPTIONS: ReadonlyArray<{ value: number; label: string }> = [
  { value: 0, label: 'Off' },
  { value: 30, label: '30s' },
  { value: 60, label: '1m' },
  { value: 300, label: '5m' },
];

export const AutoRefresh: React.FC<AutoRefreshProps> = ({ interval, onChange }) => {
  const isActive = interval > 0;

  const items = useMemo<DropdownItem[]>(
    () => INTERVAL_OPTIONS.map((opt) => ({ value: opt.value.toString(), label: opt.label })),
    [],
  );

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {isActive && (
        <Box
          aria-label="Auto-refresh active"
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'success.main',
            animation: `${pulse} 2s ease-in-out infinite`,
          }}
        />
      )}
      <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>Auto-refresh:</Typography>
      <Box
        sx={{
          // Scope the height/font to the auto-refresh trigger only — SelectMenu is
          // a shared atom used app-wide, so we style its inner Select here rather
          // than change the atom for everyone.
          '& .MuiInputBase-root': { height: STANDARD_FIELD_HEIGHT, boxSizing: 'border-box' },
          '& .MuiSelect-select': {
            py: 0,
            minHeight: 'unset',
            fontSize: '12px',
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <SelectMenu
          id="auto-refresh-interval"
          items={items}
          selectedValue={interval.toString()}
          onChange={(val) => onChange(Number(val))}
          minWidth={80}
          helperTextEnabled={false}
        />
      </Box>
    </Box>
  );
};
